import { Select } from 'antd';

import WithLoading from './WithLoading';

const SelectWithLoadingHOC = WithLoading<any>(Select);

type SelectWithLoadingType = typeof SelectWithLoadingHOC;

interface ISelectWithLoading extends SelectWithLoadingType {
  Option: typeof Select.Option;
  OptGroup: typeof Select.OptGroup;
}

const SelectWithLoading = SelectWithLoadingHOC as ISelectWithLoading;

SelectWithLoading.Option = Select.Option;
SelectWithLoading.OptGroup = Select.OptGroup;

export default SelectWithLoading;
